import { useGetIdentity, usePermissions } from 'react-admin'
import { Navigate } from 'react-router-dom'

import StatisticsContent from './StatisticsContent'
import { SYSTEM_PERMISSION_READ } from '../../config/permissions'
import { hasResourcePermission } from '../../domain/permissions'

export const STATISTICS_KEY = 'statistics'

export const StatisticsPage = () => {
  const { permissions, isPending } = usePermissions()
  const { identity, isPending: isIdentityPending } = useGetIdentity()
  if (isPending || isIdentityPending) return null
  if (!hasResourcePermission(permissions, STATISTICS_KEY, SYSTEM_PERMISSION_READ)) return <Navigate to="/" replace />
  return <StatisticsContent restrictedOrganisationId={identity?.restricted_to_organisation_id} />
}

StatisticsPage.path = '/' + STATISTICS_KEY
